module.exports = __webpack_public_path__ + "static/media/dark_plus_icon.d7852f4c.svg";